import { useAuth } from '@/state/auth/AuthContext.jsx';

export const labelSucursal = (sucursal) => {
  if (!sucursal) return 'Sin sucursal seleccionada';
  const codigo = sucursal.codigo || sucursal.code || sucursal.numero;
  return codigo ? `${codigo} · ${sucursal.nombre}` : sucursal.nombre || 'Sucursal sin nombre';
};

export default function SucursalContexto({ className = '' }) {
  const { sucursalActiva, sucursal, sucursalesHabilitadas = [], puedeCambiarSucursal, setSucursalActiva } = useAuth();
  const actual = sucursalActiva || sucursal;
  const opciones = sucursalesHabilitadas.length ? sucursalesHabilitadas : actual ? [actual] : [];
  if (!puedeCambiarSucursal || opciones.length <= 1) return <div className={`text-sm ${className}`}><span className="text-[rgb(var(--muted))]">Sucursal: </span><strong>{labelSucursal(actual)}</strong></div>;
  return <label className={`flex items-center gap-2 text-sm ${className}`}><span className="text-[rgb(var(--muted))]">Sucursal</span><select value={actual?.id || ''} onChange={(event) => void setSucursalActiva(event.target.value)} className="rounded-lg border bg-transparent px-2 py-1.5 font-medium">{opciones.map((item) => <option key={item.id} value={item.id}>{labelSucursal(item)}</option>)}</select></label>;
}
